import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import { Error404 } from '@packages/fenrir/feedback';
import { PageContainerRoot } from '@packages/fenrir/page-blocks/page-container/page-container-root';
import { PagePlain } from '@packages/fenrir/pages/page-plain';
import { TELEMETRY_CLOUD_SCANNERS_ROUTE } from 'ae-constants/routes.constants';

type NotFoundPageProps = {
  title?: string;
};

const NotFoundPage = ({ title }: NotFoundPageProps) => {
  const { t } = useTranslation('telemetryCloudScanners');
  const actionProps = {
    label: t('notFound.button'),
    to: generatePath(TELEMETRY_CLOUD_SCANNERS_ROUTE),
  };

  return (
    <PagePlain>
      <PageContainerRoot>
        <Error404 actionButton={actionProps} />
      </PageContainerRoot>
    </PagePlain>
  );
};

export default NotFoundPage;
